exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#add-sample-dialog md-dialog-content {\n  min-height: 600px; }\n", ""]);

// exports
